import { createElement } from 'react'

import { LoaderWrapperDS } from '@src/components/blocks/loader-wrapper-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { Loader } from './Loader'
import { LoaderOverlayWrapper } from './LoaderOverlayWrapper'
import LoaderSVG from './LoaderSVG'
import LoaderWrapperLegacy, { LoaderWrapperProps } from './LoaderWrapper'
import { SmartLoaderWrapper } from './SmartLoaderWrapper'

const LoaderWrapper = (props: LoaderWrapperProps) => {
  if (shouldUseDesignSystem()) {
    return createElement(LoaderWrapperDS, props)
  }
  return createElement(LoaderWrapperLegacy, props)
}

export default LoaderWrapper
export { LoaderWrapper, LoaderSVG, Loader, LoaderOverlayWrapper, SmartLoaderWrapper }
export type { LoaderWrapperProps }
